import { render, staticRenderFns } from "./RequestHotelReceipt.vue?vue&type=template&id=3bddcffa&scoped=true&"
import script from "./RequestHotelReceipt.vue?vue&type=script&lang=js&"
export * from "./RequestHotelReceipt.vue?vue&type=script&lang=js&"
import style0 from "./RequestHotelReceipt.vue?vue&type=style&index=0&id=3bddcffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddcffa",
  null
  
)

export default component.exports